module.exports = __webpack_public_path__ + "img/cocoa.03af59c1.webp";